export {isTypeLinearN};

const isTypeLinearN = (input: unknown): input is null => {
  
  return !input;
  
}